import localforage from "localforage";
import React, { type ReactNode, useContext } from "react";

interface LocalStorageContextInterface {
  getItem<T>(key: string): Promise<T | null>;
  setItem<T>(key: string, value: T): Promise<T>;
}

const LocalStorageContext = React.createContext<LocalStorageContextInterface>({
  getItem: async () => null,
  setItem: async (key, value) => value,
});

type Props = {
  children: ReactNode;
};

export const LocalStorageProvider: React.FC<Props> = ({ children }) => {
  const localForage = React.useRef<typeof localforage>(null);

  if (localForage.current == null) {
    localForage.current = localforage.createInstance({
      name: "dewey",
      driver: localforage.LOCALSTORAGE,
    });
  }

  return (
    <LocalStorageContext.Provider
      value={{
        getItem: async (key) => {
          if (!localForage.current) {
            throw new Error("localForage is not initialized");
          }
          return localForage.current.getItem(key);
        },
        setItem: async (key, value) => {
          if (!localForage.current) {
            throw new Error("localForage is not initialized");
          }

          return localForage.current?.setItem(key, value);
        },
      }}
    >
      {children}
    </LocalStorageContext.Provider>
  );
};

export const useLocalStorage = () => useContext(LocalStorageContext);
